import { render, staticRenderFns } from "./result-vote.vue?vue&type=template&id=1a1084a4&scoped=true&"
import script from "./result-vote.vue?vue&type=script&lang=js&"
export * from "./result-vote.vue?vue&type=script&lang=js&"
import style0 from "./result-vote.vue?vue&type=style&index=0&id=1a1084a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1084a4",
  null
  
)

export default component.exports